import { DACUM_MENU } from './dacumMenu';
import { LCMS_MENU } from './lcmsMenu';
import { LIA_MENU } from './liaMenu';
import { IconType } from 'react-icons';
import yearlyCalendarMenu from './yearlyCalendarMenu';

// Interface for child menu items (items inside children array)
export interface MenuChildItem {
  name: string;
  url: string;
  role: string[];
}

// Interface for parent menu items
export interface MenuItem {
  name: string;
  url: string;
  icon: IconType;
  children: MenuChildItem[];
  role: string[];
}

// Type for the entire menu array
export type Menu = MenuItem[];

// Define valid menu keys as a type
export type MenuKey = 'lia' | 'dacum' | 'lcms' | 'yearly-calendar';

export type MenuStructure = Record<MenuKey, MenuItem[]>;

// Type guard function
export function isValidMenuKey(key: string): key is MenuKey {
  return ['lia', 'dacum', 'lcms', 'yearly-calendar'].includes(key);
}

const MENU: MenuStructure = {
  lia: LIA_MENU,
  dacum: DACUM_MENU,
  lcms: LCMS_MENU,
  'yearly-calendar': yearlyCalendarMenu
};

export default MENU;
